import { useEffect } from 'react'

import { useAppState } from '@/composables/useAppState'
import { Persona } from '@/state/AppConfig'

export default function DevCommands() {
  /// #if _DEBUG
  const { actor } = useAppState()
  useEffect(() => {
    // Read url params persona
    const params = new URLSearchParams(window.location.search)

    const parsed = {
      persona: params.get('persona'),
      scenario: params.get('scenario'),
      runner: params.get('runner'),
    }
    if (parsed.runner) {
      const persona = (parsed.persona ? parsed.persona : 'pedro') as Persona
      const scenario = parsed.scenario ? parseInt(parsed.scenario) : 0
      actor.send({ type: 'DEV_RUNNER', persona, scenario })
    }
    // eslint-disable-next-line
  }, [])
  /// #endif

  return <></>
}
